import { createContext, useContext } from 'react';

import { ProgressContextProps } from '../../model/progressModel';

export const MainProgressContext = createContext<ProgressContextProps>(null!);

const useMainProgressContext = () => {
  return useContext<ProgressContextProps>(MainProgressContext);
};

export default useMainProgressContext;
